import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import Loader from 'components/Loader';
import { useAuth } from 'contexts/AuthContext';

export default function GuestGuard({ children }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <Loader />;
  }

  if (isAuthenticated) {
    return <Navigate to="/overview" replace />;
  }

  return children;
}

GuestGuard.propTypes = {
  children: PropTypes.node.isRequired
};
